import { DynamoDBServiceException as __BaseException } from "./DynamoDBServiceException";
export var AttributeAction;
(function (AttributeAction) {
    AttributeAction["ADD"] = "ADD";
    AttributeAction["DELETE"] = "DELETE";
    AttributeAction["PUT"] = "PUT";
})(AttributeAction || (AttributeAction = {}));
export var ScalarAttributeType;
(function (ScalarAttributeType) {
    ScalarAttributeType["B"] = "B";
    ScalarAttributeType["N"] = "N";
    ScalarAttributeType["S"] = "S";
})(ScalarAttributeType || (ScalarAttributeType = {}));
export var BackupStatus;
(function (BackupStatus) {
    BackupStatus["AVAILABLE"] = "AVAILABLE";
    BackupStatus["CREATING"] = "CREATING";
    BackupStatus["DELETED"] = "DELETED";
})(BackupStatus || (BackupStatus = {}));
export var BackupType;
(function (BackupType) {
    BackupType["AWS_BACKUP"] = "AWS_BACKUP";
    BackupType["SYSTEM"] = "SYSTEM";
    BackupType["USER"] = "USER";
})(BackupType || (BackupType = {}));
export var BillingMode;
(function (BillingMode) {
    BillingMode["PAY_PER_REQUEST"] = "PAY_PER_REQUEST";
    BillingMode["PROVISIONED"] = "PROVISIONED";
})(BillingMode || (BillingMode = {}));
export var KeyType;
(function (KeyType) {
    KeyType["HASH"] = "HASH";
    KeyType["RANGE"] = "RANGE";
})(KeyType || (KeyType = {}));
export var ProjectionType;
(function (ProjectionType) {
    ProjectionType["ALL"] = "ALL";
    ProjectionType["INCLUDE"] = "INCLUDE";
    ProjectionType["KEYS_ONLY"] = "KEYS_ONLY";
})(ProjectionType || (ProjectionType = {}));
export var SSEType;
(function (SSEType) {
    SSEType["AES256"] = "AES256";
    SSEType["KMS"] = "KMS";
})(SSEType || (SSEType = {}));
export var SSEStatus;
(function (SSEStatus) {
    SSEStatus["DISABLED"] = "DISABLED";
    SSEStatus["DISABLING"] = "DISABLING";
    SSEStatus["ENABLED"] = "ENABLED";
    SSEStatus["ENABLING"] = "ENABLING";
    SSEStatus["UPDATING"] = "UPDATING";
})(SSEStatus || (SSEStatus = {}));
export var StreamViewType;
(function (StreamViewType) {
    StreamViewType["KEYS_ONLY"] = "KEYS_ONLY";
    StreamViewType["NEW_AND_OLD_IMAGES"] = "NEW_AND_OLD_IMAGES";
    StreamViewType["NEW_IMAGE"] = "NEW_IMAGE";
    StreamViewType["OLD_IMAGE"] = "OLD_IMAGE";
})(StreamViewType || (StreamViewType = {}));
export var TimeToLiveStatus;
(function (TimeToLiveStatus) {
    TimeToLiveStatus["DISABLED"] = "DISABLED";
    TimeToLiveStatus["DISABLING"] = "DISABLING";
    TimeToLiveStatus["ENABLED"] = "ENABLED";
    TimeToLiveStatus["ENABLING"] = "ENABLING";
})(TimeToLiveStatus || (TimeToLiveStatus = {}));
export class BackupInUseException extends __BaseException {
    constructor(opts) {
        super({
            name: "BackupInUseException",
            $fault: "client",
            ...opts,
        });
        this.name = "BackupInUseException";
        this.$fault = "client";
        Object.setPrototypeOf(this, BackupInUseException.prototype);
    }
}
export class BackupNotFoundException extends __BaseException {
    constructor(opts) {
        super({
            name: "BackupNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "BackupNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, BackupNotFoundException.prototype);
    }
}
export var BackupTypeFilter;
(function (BackupTypeFilter) {
    BackupTypeFilter["ALL"] = "ALL";
    BackupTypeFilter["AWS_BACKUP"] = "AWS_BACKUP";
    BackupTypeFilter["SYSTEM"] = "SYSTEM";
    BackupTypeFilter["USER"] = "USER";
})(BackupTypeFilter || (BackupTypeFilter = {}));
export var ReturnConsumedCapacity;
(function (ReturnConsumedCapacity) {
    ReturnConsumedCapacity["INDEXES"] = "INDEXES";
    ReturnConsumedCapacity["NONE"] = "NONE";
    ReturnConsumedCapacity["TOTAL"] = "TOTAL";
})(ReturnConsumedCapacity || (ReturnConsumedCapacity = {}));
export var BatchStatementErrorCodeEnum;
(function (BatchStatementErrorCodeEnum) {
    BatchStatementErrorCodeEnum["AccessDenied"] = "AccessDenied";
    BatchStatementErrorCodeEnum["ConditionalCheckFailed"] = "ConditionalCheckFailed";
    BatchStatementErrorCodeEnum["DuplicateItem"] = "DuplicateItem";
    BatchStatementErrorCodeEnum["InternalServerError"] = "InternalServerError";
    BatchStatementErrorCodeEnum["ItemCollectionSizeLimitExceeded"] = "ItemCollectionSizeLimitExceeded";
    BatchStatementErrorCodeEnum["ProvisionedThroughputExceeded"] = "ProvisionedThroughputExceeded";
    BatchStatementErrorCodeEnum["RequestLimitExceeded"] = "RequestLimitExceeded";
    BatchStatementErrorCodeEnum["ResourceNotFound"] = "ResourceNotFound";
    BatchStatementErrorCodeEnum["ThrottlingError"] = "ThrottlingError";
    BatchStatementErrorCodeEnum["TransactionConflict"] = "TransactionConflict";
    BatchStatementErrorCodeEnum["ValidationError"] = "ValidationError";
})(BatchStatementErrorCodeEnum || (BatchStatementErrorCodeEnum = {}));
export class InternalServerError extends __BaseException {
    constructor(opts) {
        super({
            name: "InternalServerError",
            $fault: "server",
            ...opts,
        });
        this.name = "InternalServerError";
        this.$fault = "server";
        Object.setPrototypeOf(this, InternalServerError.prototype);
    }
}
export class RequestLimitExceeded extends __BaseException {
    constructor(opts) {
        super({
            name: "RequestLimitExceeded",
            $fault: "client",
            ...opts,
        });
        this.name = "RequestLimitExceeded";
        this.$fault = "client";
        Object.setPrototypeOf(this, RequestLimitExceeded.prototype);
    }
}
export class InvalidEndpointException extends __BaseException {
    constructor(opts) {
        super({
            name: "InvalidEndpointException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidEndpointException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidEndpointException.prototype);
        this.Message = opts.Message;
    }
}
export class ProvisionedThroughputExceededException extends __BaseException {
    constructor(opts) {
        super({
            name: "ProvisionedThroughputExceededException",
            $fault: "client",
            ...opts,
        });
        this.name = "ProvisionedThroughputExceededException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ProvisionedThroughputExceededException.prototype);
    }
}
export class ResourceNotFoundException extends __BaseException {
    constructor(opts) {
        super({
            name: "ResourceNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "ResourceNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ResourceNotFoundException.prototype);
    }
}
export var ReturnItemCollectionMetrics;
(function (ReturnItemCollectionMetrics) {
    ReturnItemCollectionMetrics["NONE"] = "NONE";
    ReturnItemCollectionMetrics["SIZE"] = "SIZE";
})(ReturnItemCollectionMetrics || (ReturnItemCollectionMetrics = {}));
export class ItemCollectionSizeLimitExceededException extends __BaseException {
    constructor(opts) {
        super({
            name: "ItemCollectionSizeLimitExceededException",
            $fault: "client",
            ...opts,
        });
        this.name = "ItemCollectionSizeLimitExceededException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ItemCollectionSizeLimitExceededException.prototype);
    }
}
export var ComparisonOperator;
(function (ComparisonOperator) {
    ComparisonOperator["BEGINS_WITH"] = "BEGINS_WITH";
    ComparisonOperator["BETWEEN"] = "BETWEEN";
    ComparisonOperator["CONTAINS"] = "CONTAINS";
    ComparisonOperator["EQ"] = "EQ";
    ComparisonOperator["GE"] = "GE";
    ComparisonOperator["GT"] = "GT";
    ComparisonOperator["IN"] = "IN";
    ComparisonOperator["LE"] = "LE";
    ComparisonOperator["LT"] = "LT";
    ComparisonOperator["NE"] = "NE";
    ComparisonOperator["NOT_CONTAINS"] = "NOT_CONTAINS";
    ComparisonOperator["NOT_NULL"] = "NOT_NULL";
    ComparisonOperator["NULL"] = "NULL";
})(ComparisonOperator || (ComparisonOperator = {}));
export class ConditionalCheckFailedException extends __BaseException {
    constructor(opts) {
        super({
            name: "ConditionalCheckFailedException",
            $fault: "client",
            ...opts,
        });
        this.name = "ConditionalCheckFailedException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ConditionalCheckFailedException.prototype);
    }
}
export var ConditionalOperator;
(function (ConditionalOperator) {
    ConditionalOperator["AND"] = "AND";
    ConditionalOperator["OR"] = "OR";
})(ConditionalOperator || (ConditionalOperator = {}));
export var ReturnValuesOnConditionCheckFailure;
(function (ReturnValuesOnConditionCheckFailure) {
    ReturnValuesOnConditionCheckFailure["ALL_OLD"] = "ALL_OLD";
    ReturnValuesOnConditionCheckFailure["NONE"] = "NONE";
})(ReturnValuesOnConditionCheckFailure || (ReturnValuesOnConditionCheckFailure = {}));
export var ContinuousBackupsStatus;
(function (ContinuousBackupsStatus) {
    ContinuousBackupsStatus["DISABLED"] = "DISABLED";
    ContinuousBackupsStatus["ENABLED"] = "ENABLED";
})(ContinuousBackupsStatus || (ContinuousBackupsStatus = {}));
export var PointInTimeRecoveryStatus;
(function (PointInTimeRecoveryStatus) {
    PointInTimeRecoveryStatus["DISABLED"] = "DISABLED";
    PointInTimeRecoveryStatus["ENABLED"] = "ENABLED";
})(PointInTimeRecoveryStatus || (PointInTimeRecoveryStatus = {}));
export class ContinuousBackupsUnavailableException extends __BaseException {
    constructor(opts) {
        super({
            name: "ContinuousBackupsUnavailableException",
            $fault: "client",
            ...opts,
        });
        this.name = "ContinuousBackupsUnavailableException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ContinuousBackupsUnavailableException.prototype);
    }
}
export var ContributorInsightsAction;
(function (ContributorInsightsAction) {
    ContributorInsightsAction["DISABLE"] = "DISABLE";
    ContributorInsightsAction["ENABLE"] = "ENABLE";
})(ContributorInsightsAction || (ContributorInsightsAction = {}));
export var ContributorInsightsStatus;
(function (ContributorInsightsStatus) {
    ContributorInsightsStatus["DISABLED"] = "DISABLED";
    ContributorInsightsStatus["DISABLING"] = "DISABLING";
    ContributorInsightsStatus["ENABLED"] = "ENABLED";
    ContributorInsightsStatus["ENABLING"] = "ENABLING";
    ContributorInsightsStatus["FAILED"] = "FAILED";
})(ContributorInsightsStatus || (ContributorInsightsStatus = {}));
export class LimitExceededException extends __BaseException {
    constructor(opts) {
        super({
            name: "LimitExceededException",
            $fault: "client",
            ...opts,
        });
        this.name = "LimitExceededException";
        this.$fault = "client";
        Object.setPrototypeOf(this, LimitExceededException.prototype);
    }
}
export class TableInUseException extends __BaseException {
    constructor(opts) {
        super({
            name: "TableInUseException",
            $fault: "client",
            ...opts,
        });
        this.name = "TableInUseException";
        this.$fault = "client";
        Object.setPrototypeOf(this, TableInUseException.prototype);
    }
}
export class TableNotFoundException extends __BaseException {
    constructor(opts) {
        super({
            name: "TableNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "TableNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, TableNotFoundException.prototype);
    }
}
export var GlobalTableStatus;
(function (GlobalTableStatus) {
    GlobalTableStatus["ACTIVE"] = "ACTIVE";
    GlobalTableStatus["CREATING"] = "CREATING";
    GlobalTableStatus["DELETING"] = "DELETING";
    GlobalTableStatus["UPDATING"] = "UPDATING";
})(GlobalTableStatus || (GlobalTableStatus = {}));
export var ReplicaStatus;
(function (ReplicaStatus) {
    ReplicaStatus["ACTIVE"] = "ACTIVE";
    ReplicaStatus["CREATING"] = "CREATING";
    ReplicaStatus["CREATION_FAILED"] = "CREATION_FAILED";
    ReplicaStatus["DELETING"] = "DELETING";
    ReplicaStatus["INACCESSIBLE_ENCRYPTION_CREDENTIALS"] = "INACCESSIBLE_ENCRYPTION_CREDENTIALS";
    ReplicaStatus["REGION_DISABLED"] = "REGION_DISABLED";
    ReplicaStatus["UPDATING"] = "UPDATING";
})(ReplicaStatus || (ReplicaStatus = {}));
export var TableClass;
(function (TableClass) {
    TableClass["STANDARD"] = "STANDARD";
    TableClass["STANDARD_INFREQUENT_ACCESS"] = "STANDARD_INFREQUENT_ACCESS";
})(TableClass || (TableClass = {}));
export class GlobalTableAlreadyExistsException extends __BaseException {
    constructor(opts) {
        super({
            name: "GlobalTableAlreadyExistsException",
            $fault: "client",
            ...opts,
        });
        this.name = "GlobalTableAlreadyExistsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, GlobalTableAlreadyExistsException.prototype);
    }
}
export var IndexStatus;
(function (IndexStatus) {
    IndexStatus["ACTIVE"] = "ACTIVE";
    IndexStatus["CREATING"] = "CREATING";
    IndexStatus["DELETING"] = "DELETING";
    IndexStatus["UPDATING"] = "UPDATING";
})(IndexStatus || (IndexStatus = {}));
export var TableStatus;
(function (TableStatus) {
    TableStatus["ACTIVE"] = "ACTIVE";
    TableStatus["ARCHIVED"] = "ARCHIVED";
    TableStatus["ARCHIVING"] = "ARCHIVING";
    TableStatus["CREATING"] = "CREATING";
    TableStatus["DELETING"] = "DELETING";
    TableStatus["INACCESSIBLE_ENCRYPTION_CREDENTIALS"] = "INACCESSIBLE_ENCRYPTION_CREDENTIALS";
    TableStatus["UPDATING"] = "UPDATING";
})(TableStatus || (TableStatus = {}));
export class ResourceInUseException extends __BaseException {
    constructor(opts) {
        super({
            name: "ResourceInUseException",
            $fault: "client",
            ...opts,
        });
        this.name = "ResourceInUseException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ResourceInUseException.prototype);
    }
}
export var ReturnValue;
(function (ReturnValue) {
    ReturnValue["ALL_NEW"] = "ALL_NEW";
    ReturnValue["ALL_OLD"] = "ALL_OLD";
    ReturnValue["NONE"] = "NONE";
    ReturnValue["UPDATED_NEW"] = "UPDATED_NEW";
    ReturnValue["UPDATED_OLD"] = "UPDATED_OLD";
})(ReturnValue || (ReturnValue = {}));
export class TransactionConflictException extends __BaseException {
    constructor(opts) {
        super({
            name: "TransactionConflictException",
            $fault: "client",
            ...opts,
        });
        this.name = "TransactionConflictException";
        this.$fault = "client";
        Object.setPrototypeOf(this, TransactionConflictException.prototype);
    }
}
export var ExportFormat;
(function (ExportFormat) {
    ExportFormat["DYNAMODB_JSON"] = "DYNAMODB_JSON";
    ExportFormat["ION"] = "ION";
})(ExportFormat || (ExportFormat = {}));
export var ExportStatus;
(function (ExportStatus) {
    ExportStatus["COMPLETED"] = "COMPLETED";
    ExportStatus["FAILED"] = "FAILED";
    ExportStatus["IN_PROGRESS"] = "IN_PROGRESS";
})(ExportStatus || (ExportStatus = {}));
export var S3SseAlgorithm;
(function (S3SseAlgorithm) {
    S3SseAlgorithm["AES256"] = "AES256";
    S3SseAlgorithm["KMS"] = "KMS";
})(S3SseAlgorithm || (S3SseAlgorithm = {}));
export class ExportNotFoundException extends __BaseException {
    constructor(opts) {
        super({
            name: "ExportNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "ExportNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ExportNotFoundException.prototype);
    }
}
export class GlobalTableNotFoundException extends __BaseException {
    constructor(opts) {
        super({
            name: "GlobalTableNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "GlobalTableNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, GlobalTableNotFoundException.prototype);
    }
}
export var ImportStatus;
(function (ImportStatus) {
    ImportStatus["CANCELLED"] = "CANCELLED";
    ImportStatus["CANCELLING"] = "CANCELLING";
    ImportStatus["COMPLETED"] = "COMPLETED";
    ImportStatus["FAILED"] = "FAILED";
    ImportStatus["IN_PROGRESS"] = "IN_PROGRESS";
})(ImportStatus || (ImportStatus = {}));
export var InputCompressionType;
(function (InputCompressionType) {
    InputCompressionType["GZIP"] = "GZIP";
    InputCompressionType["NONE"] = "NONE";
    InputCompressionType["ZSTD"] = "ZSTD";
})(InputCompressionType || (InputCompressionType = {}));
export var InputFormat;
(function (InputFormat) {
    InputFormat["CSV"] = "CSV";
    InputFormat["DYNAMODB_JSON"] = "DYNAMODB_JSON";
    InputFormat["ION"] = "ION";
})(InputFormat || (InputFormat = {}));
export class ImportNotFoundException extends __BaseException {
    constructor(opts) {
        super({
            name: "ImportNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "ImportNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ImportNotFoundException.prototype);
    }
}
export var DestinationStatus;
(function (DestinationStatus) {
    DestinationStatus["ACTIVE"] = "ACTIVE";
    DestinationStatus["DISABLED"] = "DISABLED";
    DestinationStatus["DISABLING"] = "DISABLING";
    DestinationStatus["ENABLE_FAILED"] = "ENABLE_FAILED";
    DestinationStatus["ENABLING"] = "ENABLING";
})(DestinationStatus || (DestinationStatus = {}));
export class DuplicateItemException extends __BaseException {
    constructor(opts) {
        super({
            name: "DuplicateItemException",
            $fault: "client",
            ...opts,
        });
        this.name = "DuplicateItemException";
        this.$fault = "client";
        Object.setPrototypeOf(this, DuplicateItemException.prototype);
    }
}
export class IdempotentParameterMismatchException extends __BaseException {
    constructor(opts) {
        super({
            name: "IdempotentParameterMismatchException",
            $fault: "client",
            ...opts,
        });
        this.name = "IdempotentParameterMismatchException";
        this.$fault = "client";
        Object.setPrototypeOf(this, IdempotentParameterMismatchException.prototype);
        this.Message = opts.Message;
    }
}
export class TransactionInProgressException extends __BaseException {
    constructor(opts) {
        super({
            name: "TransactionInProgressException",
            $fault: "client",
            ...opts,
        });
        this.name = "TransactionInProgressException";
        this.$fault = "client";
        Object.setPrototypeOf(this, TransactionInProgressException.prototype);
        this.Message = opts.Message;
    }
}
export class ExportConflictException extends __BaseException {
    constructor(opts) {
        super({
            name: "ExportConflictException",
            $fault: "client",
            ...opts,
        });
        this.name = "ExportConflictException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ExportConflictException.prototype);
    }
}
export class InvalidExportTimeException extends __BaseException {
    constructor(opts) {
        super({
            name: "InvalidExportTimeException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidExportTimeException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidExportTimeException.prototype);
    }
}
export class PointInTimeRecoveryUnavailableException extends __BaseException {
    constructor(opts) {
        super({
            name: "PointInTimeRecoveryUnavailableException",
            $fault: "client",
            ...opts,
        });
        this.name = "PointInTimeRecoveryUnavailableException";
        this.$fault = "client";
        Object.setPrototypeOf(this, PointInTimeRecoveryUnavailableException.prototype);
    }
}
export class ImportConflictException extends __BaseException {
    constructor(opts) {
        super({
            name: "ImportConflictException",
            $fault: "client",
            ...opts,
        });
        this.name = "ImportConflictException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ImportConflictException.prototype);
    }
}
export var Select;
(function (Select) {
    Select["ALL_ATTRIBUTES"] = "ALL_ATTRIBUTES";
    Select["ALL_PROJECTED_ATTRIBUTES"] = "ALL_PROJECTED_ATTRIBUTES";
    Select["COUNT"] = "COUNT";
    Select["SPECIFIC_ATTRIBUTES"] = "SPECIFIC_ATTRIBUTES";
})(Select || (Select = {}));
export class TableAlreadyExistsException extends __BaseException {
    constructor(opts) {
        super({
            name: "TableAlreadyExistsException",
            $fault: "client",
            ...opts,
        });
        this.name = "TableAlreadyExistsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, TableAlreadyExistsException.prototype);
    }
}
export class InvalidRestoreTimeException extends __BaseException {
    constructor(opts) {
        super({
            name: "InvalidRestoreTimeException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidRestoreTimeException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidRestoreTimeException.prototype);
    }
}
export class ReplicaAlreadyExistsException extends __BaseException {
    constructor(opts) {
        super({
            name: "ReplicaAlreadyExistsException",
            $fault: "client",
            ...opts,
        });
        this.name = "ReplicaAlreadyExistsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ReplicaAlreadyExistsException.prototype);
    }
}
export class ReplicaNotFoundException extends __BaseException {
    constructor(opts) {
        super({
            name: "ReplicaNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "ReplicaNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ReplicaNotFoundException.prototype);
    }
}
export class IndexNotFoundException extends __BaseException {
    constructor(opts) {
        super({
            name: "IndexNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "IndexNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, IndexNotFoundException.prototype);
    }
}
export var AttributeValue;
(function (AttributeValue) {
    AttributeValue.visit = (value, visitor) => {
        if (value.S !== undefined)
            return visitor.S(value.S);
        if (value.N !== undefined)
            return visitor.N(value.N);
        if (value.B !== undefined)
            return visitor.B(value.B);
        if (value.SS !== undefined)
            return visitor.SS(value.SS);
        if (value.NS !== undefined)
            return visitor.NS(value.NS);
        if (value.BS !== undefined)
            return visitor.BS(value.BS);
        if (value.M !== undefined)
            return visitor.M(value.M);
        if (value.L !== undefined)
            return visitor.L(value.L);
        if (value.NULL !== undefined)
            return visitor.NULL(value.NULL);
        if (value.BOOL !== undefined)
            return visitor.BOOL(value.BOOL);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AttributeValue || (AttributeValue = {}));
export class TransactionCanceledException extends __BaseException {
    constructor(opts) {
        super({
            name: "TransactionCanceledException",
            $fault: "client",
            ...opts,
        });
        this.name = "TransactionCanceledException";
        this.$fault = "client";
        Object.setPrototypeOf(this, TransactionCanceledException.prototype);
        this.Message = opts.Message;
        this.CancellationReasons = opts.CancellationReasons;
    }
}
export const ArchivalSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AttributeDefinitionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AutoScalingTargetTrackingScalingPolicyConfigurationDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AutoScalingPolicyDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AutoScalingTargetTrackingScalingPolicyConfigurationUpdateFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AutoScalingPolicyUpdateFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AutoScalingSettingsDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AutoScalingSettingsUpdateFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BackupDetailsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const KeySchemaElementFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ProvisionedThroughputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SourceTableDetailsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ProjectionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GlobalSecondaryIndexInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LocalSecondaryIndexInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SSEDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StreamSpecificationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TimeToLiveDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SourceTableFeatureDetailsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BackupDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BackupSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CapacityFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ConsumedCapacityFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BatchStatementErrorFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BillingModeSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PointInTimeRecoveryDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ContinuousBackupsDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ContributorInsightsSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateBackupInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateBackupOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateGlobalSecondaryIndexActionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReplicaFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateGlobalTableInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ProvisionedThroughputOverrideFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReplicaGlobalSecondaryIndexDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TableClassSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReplicaDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GlobalTableDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateGlobalTableOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateReplicaActionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReplicaGlobalSecondaryIndexFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateReplicationGroupMemberActionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GlobalSecondaryIndexFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LocalSecondaryIndexFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SSESpecificationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TagFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateTableInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ProvisionedThroughputDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GlobalSecondaryIndexDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LocalSecondaryIndexDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RestoreSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TableDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateTableOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CsvOptionsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteBackupInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteBackupOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteGlobalSecondaryIndexActionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteReplicaActionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteReplicationGroupMemberActionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteTableInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteTableOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeBackupInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeBackupOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeContinuousBackupsInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeContinuousBackupsOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeContributorInsightsInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const FailureExceptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeContributorInsightsOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeEndpointsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EndpointFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeEndpointsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeExportInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ExportDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeExportOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeGlobalTableInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeGlobalTableOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeGlobalTableSettingsInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReplicaGlobalSecondaryIndexSettingsDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReplicaSettingsDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeGlobalTableSettingsOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeImportInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const InputFormatOptionsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const S3BucketSourceFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TableCreationParametersFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ImportTableDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeImportOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeKinesisStreamingDestinationInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const KinesisDataStreamDestinationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeKinesisStreamingDestinationOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeLimitsInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeLimitsOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeTableInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeTableOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeTableReplicaAutoScalingInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReplicaGlobalSecondaryIndexAutoScalingDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReplicaAutoScalingDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TableAutoScalingDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeTableReplicaAutoScalingOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeTimeToLiveInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeTimeToLiveOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const KinesisStreamingDestinationInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const KinesisStreamingDestinationOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ExportTableToPointInTimeInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ExportTableToPointInTimeOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ImportTableInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ImportTableOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListBackupsInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListBackupsOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListContributorInsightsInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListContributorInsightsOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListExportsInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ExportSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListExportsOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListGlobalTablesInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GlobalTableFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListGlobalTablesOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListImportsInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ImportSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListImportsOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListTablesInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListTablesOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListTagsOfResourceInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListTagsOfResourceOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RestoreTableFromBackupInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RestoreTableFromBackupOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RestoreTableToPointInTimeInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RestoreTableToPointInTimeOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TagResourceInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UntagResourceInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PointInTimeRecoverySpecificationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateContinuousBackupsInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateContinuousBackupsOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateContributorInsightsInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateContributorInsightsOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReplicaUpdateFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateGlobalTableInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateGlobalTableOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GlobalTableGlobalSecondaryIndexSettingsUpdateFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReplicaGlobalSecondaryIndexSettingsUpdateFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReplicaSettingsUpdateFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateGlobalTableSettingsInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateGlobalTableSettingsOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateGlobalSecondaryIndexActionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GlobalSecondaryIndexUpdateFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateReplicationGroupMemberActionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReplicationGroupUpdateFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateTableInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateTableOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GlobalSecondaryIndexAutoScalingUpdateFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReplicaGlobalSecondaryIndexAutoScalingUpdateFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReplicaAutoScalingUpdateFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateTableReplicaAutoScalingInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateTableReplicaAutoScalingOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TimeToLiveSpecificationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateTimeToLiveInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateTimeToLiveOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AttributeValueFilterSensitiveLog = (obj) => {
    if (obj.S !== undefined)
        return { S: obj.S };
    if (obj.N !== undefined)
        return { N: obj.N };
    if (obj.B !== undefined)
        return { B: obj.B };
    if (obj.SS !== undefined)
        return { SS: obj.SS };
    if (obj.NS !== undefined)
        return { NS: obj.NS };
    if (obj.BS !== undefined)
        return { BS: obj.BS };
    if (obj.M !== undefined)
        return {
            M: Object.entries(obj.M).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
        };
    if (obj.L !== undefined)
        return { L: obj.L.map((item) => AttributeValueFilterSensitiveLog(item)) };
    if (obj.NULL !== undefined)
        return { NULL: obj.NULL };
    if (obj.BOOL !== undefined)
        return { BOOL: obj.BOOL };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const AttributeValueUpdateFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Value && { Value: AttributeValueFilterSensitiveLog(obj.Value) }),
});
export const BatchStatementRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Parameters && { Parameters: obj.Parameters.map((item) => AttributeValueFilterSensitiveLog(item)) }),
});
export const BatchStatementResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Item && {
        Item: Object.entries(obj.Item).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const CancellationReasonFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Item && {
        Item: Object.entries(obj.Item).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const ConditionFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.AttributeValueList && {
        AttributeValueList: obj.AttributeValueList.map((item) => AttributeValueFilterSensitiveLog(item)),
    }),
});
export const DeleteRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Key && {
        Key: Object.entries(obj.Key).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const ExecuteStatementInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Parameters && { Parameters: obj.Parameters.map((item) => AttributeValueFilterSensitiveLog(item)) }),
});
export const GetFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Key && {
        Key: Object.entries(obj.Key).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const GetItemInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Key && {
        Key: Object.entries(obj.Key).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const GetItemOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Item && {
        Item: Object.entries(obj.Item).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const ItemCollectionMetricsFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ItemCollectionKey && {
        ItemCollectionKey: Object.entries(obj.ItemCollectionKey).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const ItemResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Item && {
        Item: Object.entries(obj.Item).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const ParameterizedStatementFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Parameters && { Parameters: obj.Parameters.map((item) => AttributeValueFilterSensitiveLog(item)) }),
});
export const PutRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Item && {
        Item: Object.entries(obj.Item).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const KeysAndAttributesFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Keys && {
        Keys: obj.Keys.map((item) => Object.entries(item).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {})),
    }),
});
export const TransactGetItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Get && { Get: GetFilterSensitiveLog(obj.Get) }),
});
export const BatchExecuteStatementInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Statements && { Statements: obj.Statements.map((item) => BatchStatementRequestFilterSensitiveLog(item)) }),
});
export const BatchExecuteStatementOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Responses && { Responses: obj.Responses.map((item) => BatchStatementResponseFilterSensitiveLog(item)) }),
});
export const ExecuteTransactionInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.TransactStatements && {
        TransactStatements: obj.TransactStatements.map((item) => ParameterizedStatementFilterSensitiveLog(item)),
    }),
});
export const ExecuteTransactionOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Responses && { Responses: obj.Responses.map((item) => ItemResponseFilterSensitiveLog(item)) }),
});
export const TransactGetItemsOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Responses && { Responses: obj.Responses.map((item) => ItemResponseFilterSensitiveLog(item)) }),
});
export const BatchGetItemInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.RequestItems && {
        RequestItems: Object.entries(obj.RequestItems).reduce((acc, [key, value]) => ((acc[key] = KeysAndAttributesFilterSensitiveLog(value)), acc), {}),
    }),
});
export const ExpectedAttributeValueFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Value && { Value: AttributeValueFilterSensitiveLog(obj.Value) }),
    ...(obj.AttributeValueList && {
        AttributeValueList: obj.AttributeValueList.map((item) => AttributeValueFilterSensitiveLog(item)),
    }),
});
export const TransactGetItemsInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.TransactItems && { TransactItems: obj.TransactItems.map((item) => TransactGetItemFilterSensitiveLog(item)) }),
});
export const TransactWriteItemsOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ItemCollectionMetrics && {
        ItemCollectionMetrics: Object.entries(obj.ItemCollectionMetrics).reduce((acc, [key, value]) => ((acc[key] = value.map((item) => ItemCollectionMetricsFilterSensitiveLog(item))), acc), {}),
    }),
});
export const ConditionCheckFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Key && {
        Key: Object.entries(obj.Key).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.ExpressionAttributeValues && {
        ExpressionAttributeValues: Object.entries(obj.ExpressionAttributeValues).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const DeleteFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Key && {
        Key: Object.entries(obj.Key).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.ExpressionAttributeValues && {
        ExpressionAttributeValues: Object.entries(obj.ExpressionAttributeValues).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const PutFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Item && {
        Item: Object.entries(obj.Item).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.ExpressionAttributeValues && {
        ExpressionAttributeValues: Object.entries(obj.ExpressionAttributeValues).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const UpdateFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Key && {
        Key: Object.entries(obj.Key).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.ExpressionAttributeValues && {
        ExpressionAttributeValues: Object.entries(obj.ExpressionAttributeValues).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const DeleteItemOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Attributes && {
        Attributes: Object.entries(obj.Attributes).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.ItemCollectionMetrics && {
        ItemCollectionMetrics: ItemCollectionMetricsFilterSensitiveLog(obj.ItemCollectionMetrics),
    }),
});
export const ExecuteStatementOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Items && {
        Items: obj.Items.map((item) => Object.entries(item).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {})),
    }),
    ...(obj.LastEvaluatedKey && {
        LastEvaluatedKey: Object.entries(obj.LastEvaluatedKey).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const PutItemOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Attributes && {
        Attributes: Object.entries(obj.Attributes).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.ItemCollectionMetrics && {
        ItemCollectionMetrics: ItemCollectionMetricsFilterSensitiveLog(obj.ItemCollectionMetrics),
    }),
});
export const QueryOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Items && {
        Items: obj.Items.map((item) => Object.entries(item).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {})),
    }),
    ...(obj.LastEvaluatedKey && {
        LastEvaluatedKey: Object.entries(obj.LastEvaluatedKey).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const ScanOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Items && {
        Items: obj.Items.map((item) => Object.entries(item).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {})),
    }),
    ...(obj.LastEvaluatedKey && {
        LastEvaluatedKey: Object.entries(obj.LastEvaluatedKey).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const UpdateItemOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Attributes && {
        Attributes: Object.entries(obj.Attributes).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.ItemCollectionMetrics && {
        ItemCollectionMetrics: ItemCollectionMetricsFilterSensitiveLog(obj.ItemCollectionMetrics),
    }),
});
export const WriteRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.PutRequest && { PutRequest: PutRequestFilterSensitiveLog(obj.PutRequest) }),
    ...(obj.DeleteRequest && { DeleteRequest: DeleteRequestFilterSensitiveLog(obj.DeleteRequest) }),
});
export const BatchGetItemOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Responses && {
        Responses: Object.entries(obj.Responses).reduce((acc, [key, value]) => ((acc[key] = value.map((item) => Object.entries(item).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}))),
            acc), {}),
    }),
    ...(obj.UnprocessedKeys && {
        UnprocessedKeys: Object.entries(obj.UnprocessedKeys).reduce((acc, [key, value]) => ((acc[key] = KeysAndAttributesFilterSensitiveLog(value)), acc), {}),
    }),
});
export const ScanInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ScanFilter && {
        ScanFilter: Object.entries(obj.ScanFilter).reduce((acc, [key, value]) => ((acc[key] = ConditionFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.ExclusiveStartKey && {
        ExclusiveStartKey: Object.entries(obj.ExclusiveStartKey).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.ExpressionAttributeValues && {
        ExpressionAttributeValues: Object.entries(obj.ExpressionAttributeValues).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const BatchWriteItemInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.RequestItems && {
        RequestItems: Object.entries(obj.RequestItems).reduce((acc, [key, value]) => ((acc[key] = value.map((item) => WriteRequestFilterSensitiveLog(item))), acc), {}),
    }),
});
export const DeleteItemInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Key && {
        Key: Object.entries(obj.Key).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.Expected && {
        Expected: Object.entries(obj.Expected).reduce((acc, [key, value]) => ((acc[key] = ExpectedAttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.ExpressionAttributeValues && {
        ExpressionAttributeValues: Object.entries(obj.ExpressionAttributeValues).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const PutItemInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Item && {
        Item: Object.entries(obj.Item).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.Expected && {
        Expected: Object.entries(obj.Expected).reduce((acc, [key, value]) => ((acc[key] = ExpectedAttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.ExpressionAttributeValues && {
        ExpressionAttributeValues: Object.entries(obj.ExpressionAttributeValues).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const QueryInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.KeyConditions && {
        KeyConditions: Object.entries(obj.KeyConditions).reduce((acc, [key, value]) => ((acc[key] = ConditionFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.QueryFilter && {
        QueryFilter: Object.entries(obj.QueryFilter).reduce((acc, [key, value]) => ((acc[key] = ConditionFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.ExclusiveStartKey && {
        ExclusiveStartKey: Object.entries(obj.ExclusiveStartKey).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.ExpressionAttributeValues && {
        ExpressionAttributeValues: Object.entries(obj.ExpressionAttributeValues).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const BatchWriteItemOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.UnprocessedItems && {
        UnprocessedItems: Object.entries(obj.UnprocessedItems).reduce((acc, [key, value]) => ((acc[key] = value.map((item) => WriteRequestFilterSensitiveLog(item))), acc), {}),
    }),
    ...(obj.ItemCollectionMetrics && {
        ItemCollectionMetrics: Object.entries(obj.ItemCollectionMetrics).reduce((acc, [key, value]) => ((acc[key] = value.map((item) => ItemCollectionMetricsFilterSensitiveLog(item))), acc), {}),
    }),
});
export const UpdateItemInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Key && {
        Key: Object.entries(obj.Key).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.AttributeUpdates && {
        AttributeUpdates: Object.entries(obj.AttributeUpdates).reduce((acc, [key, value]) => ((acc[key] = AttributeValueUpdateFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.Expected && {
        Expected: Object.entries(obj.Expected).reduce((acc, [key, value]) => ((acc[key] = ExpectedAttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.ExpressionAttributeValues && {
        ExpressionAttributeValues: Object.entries(obj.ExpressionAttributeValues).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
});
export const TransactWriteItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ConditionCheck && { ConditionCheck: ConditionCheckFilterSensitiveLog(obj.ConditionCheck) }),
    ...(obj.Put && { Put: PutFilterSensitiveLog(obj.Put) }),
    ...(obj.Delete && { Delete: DeleteFilterSensitiveLog(obj.Delete) }),
    ...(obj.Update && { Update: UpdateFilterSensitiveLog(obj.Update) }),
});
export const TransactWriteItemsInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.TransactItems && {
        TransactItems: obj.TransactItems.map((item) => TransactWriteItemFilterSensitiveLog(item)),
    }),
});
